import slider from './components/slider.js'
import gallery from './components/gallery.js'
import newsletter from './components/newsletter.js'
import grid from './components/grid.js'
import isotope from './components/isotope.js'

export default {
  init() {
    slider.init();
    gallery.init();
    newsletter.init();
    grid.init();
    isotope.init();
  },
};


// WEBPACK FOOTER //
// ./scripts/htheme/pagebuilder/pagebuilder.js